import { useState } from "react";
import { authEndpoints } from "../../api/endpoints";

export default function useForgotPassword(apiClient, showMsg = null) {
  const [usernameOrEmail, setUsernameOrEmail] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    try {
      await apiClient.post(authEndpoints.forgotpassword, {
        username_or_email: usernameOrEmail,
      });
      showMsg?.("Neue Zugangsdaten wurden versendet!");
      return true;
    } catch (error) {
      console.warn(error);
      showMsg?.("Keine gültige Eingabe!", "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    loading,
    usernameOrEmail: { value: usernameOrEmail, setValue: setUsernameOrEmail },
  };
}
